import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_plus_line: SvgIconData = {
  viewBox: '0 0 16 16',
  element: (
    <path
      d="M7.99999 1.3335V14.6668M14.6667 8.00016L1.33333 8.00016"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
